<script>
    import Track from "./Track.svelte"
    import { doc } from "../util/stores.js"

    export let addNewTrack, removeTrack

    let tracks;

    doc.subscribe(value => {
        tracks = value['boards']['Characters']
        //console.log(tracks)
    })

    

</script>

<div class='tracks_lane_flex'>
    {#each tracks as track, i}
        <Track track_index={i} modules={track['modules']} remove_callback={removeTrack} page='Characters'></Track>
    {/each}
    <button on:click={()=>{addNewTrack('Characters')}}></button>
</div>

<style lang="scss">
    @use "styles/global.scss";

    .tracks_lane_flex{
        width: 100%;
        height: 100%;

        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-content: flex-start;

        overflow: hidden;
        overflow-x: scroll;

        @include custom_scrollbar($vertical:false);
        &::-webkit-scrollbar-thumb{
            background-color: $grey3;
        }

        button{
            @include clear_button_style;

            width: 128px;
            height: 128px;

            flex-shrink: 0;

            margin-left: 48px;
            margin-right: 48px;
            border-radius: 16px;

            align-self: center;

            background-color: transparent;
            background-image: url('../pics/icons/plus.svg');
            background-position: center center;
            background-repeat:no-repeat;
            background-size: 50% 50%;

            transition: 0.3s ease;

            &:hover{
                //background-color: $grey5;
                background-color: $accent_green;
                box-shadow: 0px 0px 12px 1px rgba(0, 0, 0, 0.192);
            }
        }
    }

    .right_side_panel{
        width: 0px;
        height: 100%;

        justify-self: flex-end;
    }
</style>